import React, { useState } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { useSelector } from "react-redux";

const EmojiPicker = props => {
  const { handleSetDefinedTemplate, messageText, textMode, text, emailCursor, emailTextRef } =
    props;
  const { textMode: textModeRedux } = useSelector(state => state.lead);

  const handleEmoji = e => {
    if (textModeRedux === "Email" || textMode === 1) {
      const editor = document.getElementById("rich-text");
      if (!editor) {
        console.error("Editor element not found");
        return;
      }
      editor.focus(); // Ensure editor is focused
      if (!emailCursor) {
        console.error("No cursor position saved");
        return; // If no cursor position saved, do nothing
      }
      const selection = window.getSelection();
      if (!selection) {
        console.error("Unable to get window selection");
        return;
      }
      selection.removeAllRanges();
      selection.addRange(emailCursor); // Restore cursor position
      // Insert emoji at restored cursor position
      const range = selection.getRangeAt(0);
      if (!range) {
        console.error("Unable to get range from selection");
        return;
      }
      range.deleteContents(); // Remove any selected text

      const emojiNode = document.createTextNode(e.native);
      range.insertNode(emojiNode);

      // Move cursor after emoji
      range.setStartAfter(emojiNode);
      range.setEndAfter(emojiNode);
      selection.removeAllRanges();
      selection.addRange(range);
    } else {
      textMode === 0
        ? handleSetDefinedTemplate(text.current.value + e.native)
        : handleSetDefinedTemplate(e.native);
    }
  };

  return (
    <Picker data={data} theme="light" previewPosition="none" onEmojiSelect={e => handleEmoji(e)} />
  );
};

export default EmojiPicker;
